<template>
  <div id="app">
    <div class="topbar has-text-white">
      <div class="columns is-gapless is-mobile">
        <div class="column is-narrow">
          <div class="burger-menu is-pulled-left is-hidden-tablet" v-on:click="openMenu">
            <b-icon pack="fa" icon="bars" size="is-medium" class="rp-menu-bar"></b-icon>
          </div>
          <div class="system-name">
            <router-link :to="{ name: 'Home' }">
              <span class="is-size-4 is-hidden-mobile has-text-white">
                {{ 'R-Shop' }}
              </span>
            </router-link>
          </div>
        </div>
        <div class="column has-text-right" v-if="getIsRMP === 'false'">
          <span class="test rshop-version-container">v.{{ version }}</span>
          <b-dropdown class="language-dropdown has-text-left" position="is-bottom-left">
            <div class="translation" slot="trigger">
              <div v-if="$i18n.locale() === 'en'"><flag iso="US" /> EN</div>
              <div v-else-if="$i18n.locale() === 'th'"><flag iso="TH" /> TH</div>
              <div v-else-if="$i18n.locale() === 'vi'"><flag iso="VN" /> VI</div>
            </div>
            <b-dropdown-item 
              v-for="(lang, index) in getLanguageSwitcherList"
              v-bind:key="index"
              v-on:click="setLanguage(lang)"
            >
              <span v-if="lang === 'th'"><flag iso="TH" /> Thai</span>
              <span v-if="lang === 'en'"><flag iso="US" /> English</span>
              <span v-if="lang === 'vi'"><flag iso="VN" /> Vietnam</span>
            </b-dropdown-item>
          </b-dropdown>
          <rshop-manual-link :lang="$i18n.locale()" rmp="no"/>
          <template v-if="account.webName != ''">
            &nbsp;|&nbsp;
            <span v-on:click="logoutConfirm">
              <b-icon class="rpshop-logout-button" v-bind:title="$t('_logout')" pack="fa" icon="power-off"></b-icon>
            </span>
          </template>
        </div>
        <div class="column has-text-right is-rmp" v-else>
          <span class="test rshop-version-container">v.{{ version }}</span>
          <rshop-manual-link :lang="$i18n.locale()" rmp="yes"/>
          <template v-if="account.webName != ''">
            <div class="rmp-widget" id="rmp_widget" data-source-app-id="4"></div>
          </template>
        </div>
      </div>
    </div>
    <div class="section-main columns is-gapless">
      <div class="shop-sidebar column is-narrow is-hidden-mobile">
        <sidebar v-model="showSidebarSubMenus"></sidebar>
      </div>
      <div class="shop-content column">
        <router-view></router-view>
      </div>
    </div>
    <div class="modal menu-modal" v-bind:class="{ 'is-active': menuModal }">
      <div class="modal-background"></div>
      <div class="modal-content">
        <sidebar v-model="showSidebarSubMenus" v-on:toggleSubMenu="toggleSidebarSubMenu" v-on:closemenu="closeMenu" show-close-button="true"></sidebar>
        <sidebar-settings v-if="showSidebarSubMenus" v-on:closemenu="closeMenu"></sidebar-settings>
      </div>
    </div>
  </div>
</template>

<script>
// import VueLocalStorage from 'vue-localstorage'

const Sidebar = () => import('./components/share/sidebar')
const SidebarSettings = () => import('./components/share/sidebar_settings')
const RshopManualLink = () => import('./components/share/rshop_manual')
import { mapState, mapActions } from 'vuex'
import { Settings } from 'luxon'

export default {
  name: 'app',
  data: () => {
    return {
      menuModal: false,
      showSidebarSubMenus: false,
      version: ''
    }
  },
  components: {
    Sidebar,
    SidebarSettings,
    RshopManualLink
  },
  computed: {
    ...mapState({
      account: state => state.accounts
    }),
    getIsRMP () {
      return this.$localStorage.get('is_rmp')
    },
    getLanguageSwitcherList () {
      let registerCountry = this.$localStorage.get('register_country')
      if (this.$localStorage.get('multi_language', '')) {
        let multiLanguage = JSON.parse(this.$localStorage.get('multi_language', ''))
        if (multiLanguage.length > 0) {
          return ['th', 'en', 'vi']
        } else {
          if (registerCountry === 'VN') {
            return ['vi', 'en']
          } else if (registerCountry === 'MM') {
            return ['th', 'en']
          } else {
            return ['th', 'en']
          }
        }
      } else {
        if (registerCountry === 'VN') {
          return ['vi', 'en']
        } else if (registerCountry === 'MM') {
          return ['th', 'en']
        } else {
          return ['th', 'en']
        }
      }
    }
  },
  mounted () {
    this.appendRMPWidget()
    this.version = process.env.APP_VERSION

    let script = document.createElement('script')
    script.innerHTML = process.env.MICROSOFT_CLARITY_GTM
    document.getElementsByTagName('head')[0].appendChild(script)
  },
  methods: {
    ...mapActions([
      'getAccount',
      'logoutRMP',
      'setBusinessIdToken'
    ]),
    openMenu () {
      this.menuModal = true
    },
    closeMenu () {
      this.menuModal = false
    },
    toggleSidebarSubMenu (status) {
      if (status === true) {
        this.showSidebarSubMenus = true
      } else {
        this.showSidebarSubMenus = false
      }
    },
    setLanguage (language) {
      language = language.toLowerCase()
      if (language === '' || language === 'th') {
        language = 'th'
      } else if (language === 'vi') {
        language = 'vi'
      } else {
        language = 'en'
      }
      this.$i18n.set(language)
      this.$localStorage.set('language', language)
      Settings.defaultLocale = language
    },
    logoutConfirm () {
      this.$dialog.confirm({
        title: this.$t('modal_title_logout'),
        message: this.$t('modal_logout'),
        type: 'is-danger',
        cancelText: this.$t('_cancel'),
        confirmText: this.$t('_logout'),
        hasIcon: false,
        onConfirm: () => this.logout()
      })
    },
    logout () {
      console.log(this.$localStorage.remove('token'))
      console.log(this.$localStorage.remove('quota_rpshop_products'))
      console.log(this.$localStorage.remove('quota_rpshop_product_variants'))
      console.log(this.$localStorage.remove('quota_member'))
      console.log(this.$localStorage.remove('countProducts'))
      if (this.$localStorage.get('is_rmp') === 'true') {
        let logoutToken = this.$localStorage.get('logout_token')
        console.log(this.$localStorage.remove('is_rmp'))
        console.log(this.$localStorage.remove('logout_token'))
        this.logoutRMP(logoutToken).then((results) => {
          window.location = process.env.RMP_URL
        })
      } else {
        window.location = 'https://' + this.account.webName
      }
    },
    appendRMPWidget () {
      let script = document.createElement('script')
      script.setAttribute('src', process.env.RMP_WIDGET_URL)
      script.setAttribute('id', 'rmp_widget_js')
      document.body.appendChild(script)
    }
  }
}
</script>

<style lang="scss">
@charset "utf-8";
@import "~bulma/sass/utilities/initial-variables";

$primary: #122c48;
$info: #3e89db;
$order-color: #FF9800;
$tabs-link-active-color: $info;
$tabs-link-active-border-bottom-color: $info;
$link: $info;
$link-hover: $info;
$menu-item-active-background-color: none;
$menu-item-hover-background-color: none;
$menu-item-active-color: $link;


@import "~bulma";
@import "~buefy/src/scss/buefy";
@import '~vue-popperjs/dist/css/vue-popper.css';

body {
  line-height: normal;
}

.topbar {
  background-color: $order-color;
  padding: 0 20px;
  width: 100%;
  position: fixed;
  z-index: 5;

  .rshop-version-container {
    font-size: 0.8em;
    padding-right: 5px;
  }

  .burger-menu {
    line-height: 45px;
    margin: 0 20px 0 0;
    cursor: pointer;
    .rp-menu-bar{vertical-align: middle}
  }

  .system-name {
    a {
      line-height: 45px;
    }
  }

  .shop-name {
    line-height: 45px;
  }

  .translation {
    cursor: pointer;
    height: 100%;
    line-height: 45px;
  }

  .dropdown-menu {
    right: -100px !important;
    .dropdown-content {
      width: 100px;
    }
  }

  .language-dropdown {
    vertical-align: middle;
  }

  .rpshop-logout-button {
    cursor: pointer;
    position: relative;
    top: 2px;
  }
  .is-rmp {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}

a.disabled {
  background-color: #dbdbdb;
  border-color: #dbdbdb;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #7a7a7a;
  opacity: 0.5;
  cursor: not-allowed !important;
}

.section-main {
  position: relative;
  height: 100%;
  top: 48px;

  .shop-sidebar {
    width: 70px;
  }
}

.vue-dropzone {
  .dz-preview {
    .dz-error-message {
      top: 100% !important;
    }
  }
}

.menu-modal {
  .modal-content {
    max-height: 100vh;
    height: 100%;
    top: 0;
    left: 0;
    margin: 0;
  }
}

.has-icons-left {
  z-index: 0;
}

.rp-category-panel .rp-setting .dropdown-menu .dropdown-content {
  width: 100px;
}
.shop-content {
  width: 80%;
}
.croppie-container .cr-slider-wrap {
  display: none;
}
.croppie-container .cr-viewport {
  border: none;
}
.products-sorting-container {
  .sortable-ghost {
    border: 2px dashed #007EFC;

    .product-card-container {
      margin: 11px;
      div {
        display: none;
      }
    }
  }
}
#contact-form-customize-container,
#order-custom-form-customize-container {
  .sortable-ghost {
    .has-text-info {
      color: yellow !important;
    }
    .contact-form-field-detail,
    .order-custom-form-field-detail {
      color: yellow !important;
    }
  }
}

.shipping-type-settings {
  .dropdown {
    width: 100%;

    .dropdown-trigger,
    .dropdown-menu {
      width: 100%;
    }
  }
}

.quantity-range-settings-container,
.weight-range-settings-container {
  .quantity-range-field,
  .quantity-rate-field,
  .weight-range-field,
  .weight-rate-field {
    input:not([custom-class="no-padding"]) {
      padding-right: 2.25em;
    }
    input[custom-class="no-padding"] {
      margin-right: 2.25em;
    }
  }
}

.basic-setting {
  .price-volume-label-rate-mobile {
    display: none;
  }

  .price-volume-label-range-mobile {
    display: none;
  }
}

@media screen and (max-width: 768px) {
  .basic-setting {
    .ql-container {
      max-height: calc(100% - 66px);
    }

    .price-volume-label-range,
    .price-volume-range-to,
    .price-volume-label-rate {
      font-size: 0.75em;
    }

    .price-volume-label-rate-mobile {
      display: flex;
    }

    .price-volume-label-range-mobile {
      display: flex;
    }
  }

  .shop-content {
    width: 100%;
  }
  .topbar {
    .dropdown-menu {
      right: auto;
      .dropdown-content {
        width: auto;
      }
    }
  }
  .rp-category-panel .rp-setting .dropdown-menu .dropdown-content {
    width: auto;
  }

  .shop-name {
    line-height: normal !important;
  }

  .section-main {
    top: 45px;
  }
}

@media screen and (max-width: 933px) {
  .rmp-widget {
    line-height: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue